import TwoColContainer from './TwoColContainer';

export default TwoColContainer;
